import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import Radio from "../components/Radio";
import Anchor from "../components/Anchor";
import StepHeader from "../components/StepHeader";

import Animate from "../Animate";

import { FieldShape, ContentWithVarsShape } from "../utils/types";
import useDebouncedCallback from "../utils/useDebounce";

export default function FormChoice({
  id,
  title = "",
  description = "",
  htmlContent = "",
  fields = [],
  onSubmit,
  variables,
  emptyVariableFormatter,
}) {
  const [selected, setSelected] = useState(null);
  const [fieldCallback, setFieldCallback] = useState(null);
  const [disabledUI, setDisabledUI] = useState(false);
  const submited = useRef(false);
  const debouncedSubmit = useDebouncedCallback((value, time) => {
    submited.current = true;
    onSubmit(value, id);
    if (fieldCallback) {
      fieldCallback();
    }
  }, 700);

  useEffect(() => {
    if (selected && submited.current === false) {
      setDisabledUI(true);
      debouncedSubmit(selected);
    }
  }, [selected, debouncedSubmit]);

  return (
    <Animate>
      <div className="grid">
        <div className="container">
          <form>
            <StepHeader
              title={title}
              description={description}
              htmlContent={htmlContent}
              variables={variables}
              emptyVariableFormatter={emptyVariableFormatter}
            />

            <ul className="unstyled">
              {fields &&
                fields.map((field, index) => {
                  return field.type === "anchor" ? (
                    <li key={field.label + index}>
                      <Anchor
                        disabled={disabledUI}
                        url={field.url}
                        label={field.label}
                        onClick={handleOnChange}
                      />
                    </li>
                  ) : (
                    <li key={field.value + index}>
                      <Radio
                        disabled={disabledUI && selected !== field.value}
                        label={field.label}
                        subLabel={field.subLabel}
                        name={id}
                        checked={selected === field.value}
                        onChange={handleOnChange}
                        value={field.value}
                      />
                    </li>
                  );
                })}
            </ul>
          </form>
        </div>
      </div>
    </Animate>
  );

  function handleOnChange(event, callback) {
    setFieldCallback(callback);
    setSelected(event.target.getAttribute("value"));
  }
}

FormChoice.propTypes = {
  id: PropTypes.string.isRequired,
  title: ContentWithVarsShape,
  description: ContentWithVarsShape,
  htmlContent: PropTypes.string,
  fields: PropTypes.arrayOf(FieldShape),
  onSubmit: PropTypes.func.isRequired,
  variables: PropTypes.object.isRequired,
  emptyVariableFormatter: PropTypes.func,
};
